// time-range-modal.component.ts
import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-create-actions-modal",
  templateUrl: "./create-actions-modal.component.html",
  styleUrls: ["./create-actions-modal.component.scss"],
})
export class CreateActionsModalComponent implements OnInit {
  selectedStartTime: string;
  selectedEndTime: string;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private authService: AuthService
  ) {}

  ngOnInit() {}

  async closeModal() {
    const onClosedData = {
      startTime: this.selectedStartTime,
      endTime: this.selectedEndTime,
    };
    this.authService.updateTimeRange(
      this.selectedStartTime,
      this.selectedEndTime
    );
    await this.modalController.dismiss(onClosedData);
    console.log("enviado rango ", onClosedData);
    console.log("enviados ", this.selectedStartTime, this.selectedEndTime);
  }
}
